<script setup>
import { appStorage } from '@shared/utils/storage.js';

function resetStorageAndRefresh () {
	appStorage.set('articleData', {});
  appStorage.set('articleDataVersion', 0);
  window.setTimeout(() => {
  	window.location.reload(true); // Deprecated, but some browsers still respect it
  }, 300)
}
</script>

<template>
<div class="notice">
	<h1>Downloading article data</h1>
	<p>This usually takes less than 5 seconds, and only has to happen once in a while.</p>
	<p>If the content doesn't load soon, click to reset the app-storage and try again. <span class="emoji">🫣</span></p>
	<button class="btn secondary" @click.stop="resetStorageAndRefresh()">Clear download and refresh</button>
</div>
</template>

<style lang="scss" scoped>
.notice {
	margin-top: 80px;
}
.notice h1 {
	margin: 0;
	font-size: 20px;
}
.notice p {
	margin-top: .5em;
	margin-bottom: 0;
}
.notice button {
	margin-top: 1em;
}
</style>
